export const headerHeight = 60;

export function getContentHeight() {
  return window.innerHeight - headerHeight;
}
